import { UUIDv4 } from '@app/common/types/uuid'

export class MoveUsersRequestDTO {
  public licenseTypePlanId?: UUIDv4
  public licensePoolId?: UUIDv4

  constructor(
    public userIds: UUIDv4[],
    licenseTypePlanId?: UUIDv4,
    licensePoolId?: UUIDv4
  ) {
    this.licenseTypePlanId = licenseTypePlanId ? licenseTypePlanId : undefined
    this.licensePoolId = licensePoolId ? licensePoolId : undefined
  }
}
